import { backendPy } from "System/system";
import levenshtein from "fast-levenshtein";
import store from "System/reduxStore";

// -------------------------------------------------------
// -------------------------------------------------------
export const setJoinFile = (collectionid, fullfile) => async (dispatch) => {
  const file = fullfile.name;
  const path = fullfile.path.replace(/\./g, "");
  const cut = fullfile.cut;

  const result = await backendPy("files", "get_headers", {
    file,
    path,
    cut,
  });
  if (result.data) {
    const headers = result.data.headers;
    console.log("Headers are", headers);
    dispatch({ type: "SET_JOIN_FILE", collectionid, file: fullfile, headers });
  }
};

// -------------------------------------------------------
// -------------------------------------------------------
export const removeJoinHeader = (collectionid, header) => async (dispatch) => {
  dispatch({ type: "REMOVE_JOIN_HEADER", collectionid, header });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const setJoinFileMatch = (collectionid, match) => async (dispatch) => {
  dispatch({ type: "SET_JOIN_FILE_MATCH", collectionid, match });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const setJoinCollectionMatch =
  (collectionid, match) => async (dispatch) => {
    dispatch({ type: "SET_JOIN_COLLECTION_MATCH", collectionid, match });
  };

// -------------------------------------------------------
// -------------------------------------------------------
export const applyJoin__ = (collectionid, join, cb) => async (dispatch) => {
  const { collections, repository } = store.getState().project;
  const collection = collections.find((c) => c.id === collectionid);
  const collectionFiles = collection.fileids.map((x) => repository[x]);

  const input_match = join.collectionMatch;
  const linkage_file = join.file.name;
  const linkage_path = join.file.path.replace(/\./g, "");
  const linkage_cut = join.file.cut;
  const linkage_match = join.fileMatch;
  const cols = join.headers.filter((x) => x !== linkage_match);

  for (var ii = 0; ii < collectionFiles.length; ii++) {
    const input_file = collectionFiles[ii].name;
    const input_path = collectionFiles[ii].path.replace(/\./g, "");
    const input_cut = collectionFiles[ii].cut;

    await backendPy("joins", "apply_join", {
      input_file,
      input_path,
      input_cut,
      input_match,
      linkage_file,
      linkage_path,
      linkage_cut,
      linkage_match,
      cols: JSON.stringify(cols),
    });
  }
  cb();
};

// -------------------------------------------------------
// -------------------------------------------------------
export const applyJoin = (collectionid, join, cb) => async (dispatch) => {
  const { collections, repository } = store.getState().project;
  const collection = collections.find((c) => c.id === collectionid);
  const collectionFiles = collection.fileids.map((x) => repository[x]);

  const input_file = collectionFiles[0].name;
  const input_path = collectionFiles[0].path.replace(/\./g, "");
  const input_cut = collectionFiles[0].cut;
  const input_match = join.collectionMatch;

  const linkage_file = join.file.name;
  const linkage_path = join.file.path.replace(/\./g, "");
  const linkage_cut = join.file.cut;
  const linkage_match = join.fileMatch;

  const linkage_res = await backendPy("joins", "read_column", {
    file: linkage_file,
    path: linkage_path,
    cut: linkage_cut,
    column: linkage_match,
  });

  const input_res = await backendPy("joins", "read_column", {
    file: input_file,
    path: input_path,
    cut: input_cut,
    column: input_match,
  });

  if (linkage_res.data && input_res.data) {
    const linkage_data = Array.from(new Set(linkage_res.data.values));
    const input_data = Array.from(new Set(input_res.data.values));

    const register = {};
    linkage_data.forEach((x) => (register[clean(x)] = x));

    const noMatch = [];
    const direct = [], similar = [];
    const directMatches = [];
    const similarMatches = [];

    for (var ii = 0; ii < input_data.length; ii++) {
      const x = input_data[ii];
      if (register[clean(x)]) {
        directMatches.push(x);
        direct.push({
          input: x,
          linkage: register[clean(x)],
        });
      } else {
        for(const y of linkage_data) {
          const distance = levenshtein.get(clean(x), clean(y));
          if (distance < 3) {
            similarMatches.push(x);
            similar.push({
              input: x,
              linkage: y,
              distance,
            });
            break;
          }
        }
      }
    }
    for(const item of input_data) {
      if(!directMatches.includes(item) && !similarMatches.includes(item)) {
        let bestDistance = 100, bestMatch = null;
        for (const y of linkage_data) {
          const distance = levenshtein.get(clean(item), clean(y));
          if (distance < bestDistance) {
            bestDistance = distance;
            bestMatch = y;
          }
        }
        noMatch.push({
          input: item, linkage: bestMatch, bestDistance
        });
      }
    }
      cb({
        noMatch: noMatch.sort((a, b) => a.bestDistance - b.bestDistance),
        direct,
        similar: similar.sort((a, b) => a.distance - b.distance)
      });
      return;
  }
  cb(null)

};

const clean = x => {
  x = x.replace(/[^a-zA-Z0-9 ]/g, "").toUpperCase();
  x = x.replace(/ LLC/g, "")
  x = x.replace(/ INC/g, "");
  x = x.replace(/ CORPORATION/g, "");
  x = x.replace(/ CORP/g, "");
  x = x.replace(/ CO/g, "");
  x = x.replace(/ LTD/g, "");
  x = x.replace(/ LIMITED/g, "");
  x = x.replace(/ {2}/g, " ");
  return x.toUpperCase().trim();
};